import React from 'react';
export function Modal({ title, onClose, children, width = 700, maxHeight = '90vh', showClose = true }: { title: string; onClose: () => void; children: React.ReactNode; width?: number; maxHeight?: string | number; showClose?: boolean }) {
  const computedMaxHeight = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:10000 }} onClick={onClose}>
      <div style={{ background:'#fff', borderRadius:8, padding:20, maxHeight:computedMaxHeight, overflow:'auto', width, boxShadow:'0 4px 24px rgba(0,0,0,0.25)', position:'relative' }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
          <h3 style={{ margin:0 }}>{title}</h3>
          {showClose && (
            <button onClick={onClose} style={{ border:'none', background:'#eee', padding:'4px 10px', cursor:'pointer', borderRadius:4 }}>Close</button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
